export const maxLimit = [
    {
        id: 20,
        value: '20件'
    },
    {
        id: 40,
        value: '40件'
    },
    {
        id: 60,
        value: '60件'
    },
]